// extracted by mini-css-extract-plugin
module.exports = {"tileLayout":"CjwwM","loader":"k2pDb","spin":"_WQ1d","col2":"RLZCs","toiPlusHeading":"qEmtM"};